define('home/views/ActivityCardFavoriteView',[
    'backbone-marionette',
    'home/mixins/withReasonOld',
    'home/mixins/withSubviews',

    'home/views/ActivityFooterFavoriteView',

    'home/templates/activityCardFavorite',
], function (
    Marionette,
    withReason,
    withSubviews,

    ActivityFooterFavoriteView,

    activityCardFavoriteTemplate
) {

    'use strict';

    var parent = Marionette.ItemView;


    var ActivityCardFavoriteView = parent.extend({
        template: activityCardFavoriteTemplate,
        templateHelpers: function () {
            return {
                discussionRoute: this.model.thread.getDiscussionRoute(),
                threadDescriptionHTML: this.model.thread.getDefaultDescription(),
            };
        },

        initialize: function () {
            this.listenTo(this.model.thread, 'change:content', this.render);
        },

        regions: {
            footerRegion: '[data-role=footer]',
        },

        onRender: function () {
            this.activateRegion(this.footerRegion, this.createFooterView);
        },

        createFooterView: function () {
            return new ActivityFooterFavoriteView({
                el: this.footerRegion.el,
                model: this.model,
            });
        },
    });


    var proto = ActivityCardFavoriteView.prototype;
    withReason.call(proto);
    withSubviews.call(proto);

    return ActivityCardFavoriteView;
});

